import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");
const AppRoot = (
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
    hydrateRoot(rootElement, AppRoot);
} else {
    createRoot(rootElement).render(AppRoot);
}
